import React, { FC, MouseEvent, PropsWithChildren, useRef } from 'react'
import {
  overlay,
  title,
  header,
  modal,
  content,
  closeButton,
  arrowLeftButton,
  headerContent,
} from './modal.css'
import useModalEscape from './useModalEscape'
import { Icon, theme, classNames } from '@hermes/design-system'

export interface ModalProps extends PropsWithChildren {
  isOpen: boolean
  onClose: () => void
  titleText?: string
  className?: string
}

const Modal: FC<ModalProps> = ({ isOpen, onClose, titleText, className, children }) => {
  const modalRef = useRef<HTMLDivElement>(null)
  useModalEscape({ isOpen, onClose })

  const onOverlayClick = (event: MouseEvent) => {
    if (event.target === event.currentTarget) {
      onClose()
    }
  }

  if (!isOpen) {
    return null
  }

  return (
    <div className={classNames(overlay, className)} onClick={onOverlayClick}>
      <div className={modal} ref={modalRef}>
        {titleText ? (
          <div className={header}>
            <div className={headerContent}>
              <Icon className={arrowLeftButton} name="arrow-left" />
              <h2 className={title}>{titleText}</h2>
            </div>
            <Icon
              className={closeButton}
              color={theme.palette.primitives.brandBlack500}
              onClick={onClose}
              name="close"
            />
          </div>
        ) : null}
        {children ? <div className={content}>{children}</div> : null}
      </div>
    </div>
  )
}

export default Modal
